import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

import { Miscellaneous } from './Miscellaneous'

export enum PcServiceSiteSearchFields {
	searchById = 'searchById',
	searchByName = 'searchByName'
}

export enum ProcessingCenterFilterFields {
	processingCenterId = 'processingCenterId'
}

export enum AddressSearchFields {
	searchByState = 'searchByState',
	searchByCity = 'searchByCity',
	searchByAddress = 'searchByAddress'
}

export enum PcServiceSiteFormSearchFields {
	searchById = 'searchById',
	searchByName = 'searchByName',
	searchByCity = 'searchByCity',
	searchByState = 'searchByState',
	searchByAddress = 'searchByAddress'
}

export declare namespace PcServiceSite {
	interface Address {
		city: string | null
		state: string | null
		address: string | null
	}

	interface Basic {
		id: number
		serviceSite: Entity | null
		processingCenter: Entity | null
		address: Address | null
	}

	namespace Form {
		interface Add {
			processingCenterId: number | null
			serviceSiteId: LabelValue<number> | null
		}

		namespace Search {
			interface Result {
				[PcServiceSiteFormSearchFields.searchById]: Entity[]
				[PcServiceSiteFormSearchFields.searchByName]: Entity[]
				[PcServiceSiteFormSearchFields.searchByCity]: Miscellaneous.ProcessingCenter.City[]
				[PcServiceSiteFormSearchFields.searchByState]: Miscellaneous.ProcessingCenter.State[]
				[PcServiceSiteFormSearchFields.searchByAddress]: Miscellaneous.ProcessingCenter.Address[]
			}
		}
	}

	namespace Request {
		interface Add {
			processingCenterId: number
			serviceSiteId: number
		}
	}

	namespace Search {
		interface Result {
			[PcServiceSiteSearchFields.searchById]: Entity[]
			[PcServiceSiteSearchFields.searchByName]: string[]
		}

		interface Config {
			[PcServiceSiteSearchFields.searchById]: ConfigItem<PcServiceSiteSearchFields>
			[PcServiceSiteSearchFields.searchByName]: ConfigItem<PcServiceSiteSearchFields>
		}

		namespace Address {
			interface Config {
				[AddressSearchFields.searchByState]: ConfigItem<AddressSearchFields>
				[AddressSearchFields.searchByCity]: ConfigItem<AddressSearchFields>
				[AddressSearchFields.searchByAddress]: ConfigItem<AddressSearchFields>
			}

			interface Result {
				[AddressSearchFields.searchByState]: Miscellaneous.StateProvince[]
				[AddressSearchFields.searchByCity]: string[]
				[AddressSearchFields.searchByAddress]: string[]
			}
		}
	}

	namespace Filter {
		interface Config {
			[ProcessingCenterFilterFields.processingCenterId]: ConfigFilterItem<string, string>
		}
	}
}
